/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import useStore from "../AppStore";
import { clampFrac, easeInQuad } from "../util";
import path from "../path";

export default function SmartPhone(props) {
  const group = useRef(null);
  const matScreenRef = useRef(null);
  const { nodes, materials } = useGLTF(path + "/assets/smartphone.glb");

  useFrame(({ clock }) => {
    const top = useStore.getState().top;
    const f = easeInQuad(clampFrac(top, 8200, 8400));
    matScreenRef.current.color.r = 0.01 + f * 0.9;
    matScreenRef.current.color.g = 0.01 + f * 0.9;
    matScreenRef.current.color.b = 0.01 + f * 0.9;
    group.current.scale.x = 1.5 + f * 1.5;
    group.current.scale.y = 1.5 + f * 1.5;
    group.current.scale.z = 1.5 + f * 1.5;
  });

  return (
    <group
      ref={group}
      {...props}
      dispose={null}
      rotation={[Math.PI / 2, 0, Math.PI / 2]}
    >
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane_1.geometry}
        material={materials["Material.001"]}
      />
      <mesh castShadow receiveShadow geometry={nodes.Plane_2.geometry}>
        <meshBasicMaterial ref={matScreenRef} color={0x222222} />
      </mesh>
    </group>
  );
}

useGLTF.preload(path + "/assets/smartphone.glb");
